import React from 'react';
import './css/WalletBalanceCard.css';

/** Displays the already-fetched user's Gnosis xDAI wallet balance (raw wei). */
export default function WalletBalanceCard({balanceWei, language='english', theme='light'}) {
  const spanish = language === 'spanish';
  const raw = Number(balanceWei);
  const available = balanceWei != null && Number.isFinite(raw) && raw >= 0;
  const balance = available ? (raw / 1e18).toLocaleString(spanish ? 'es-ES' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
  return <div className={'tbp-wallet-balance-card '+(theme === 'light' ? 'is-light' : 'is-dark')} aria-label={spanish ? 'Saldo de Cartera Blender' : 'Blender Wallet Balance'}>
    <div className="tbp-wallet-balance-card__details">
      <span>{spanish ? 'Saldo de tu Cartera Blender' : 'Your Blender Wallet Balance'}</span>
      <strong>{balance} <small>USD</small></strong>
      <small>{spanish ? 'Saldo disponible en xDAI. El crédito disponible se muestra por separado.' : 'Available xDAI. Credit-line availability is separate.'}</small>
    </div>
    <span aria-hidden="true" className="tbp-wallet-balance-card__symbol">↔</span>
  </div>;
}
